// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"0fb0fb69","765":"5ecb3183","977":"d2dde751"}[chunkId] + ".chunk.js";
};